import { Card } from 'primereact/card';
import { Skeleton } from 'primereact/skeleton';
import React from 'react';

function ScientistSkeleton() {
  return (
    <Card className="mb-4 scientist-card">
      <Skeleton height="2rem" className="mb-2 w-16rem sm:w-18rem md:w-22rem xl:w-20rem" />
      <div className="py-2">
        <div className="flex gap-3">
          <Skeleton shape="circle" size="5rem" className="mb-2" />
          <div>
            <Skeleton className="mb-2 w-6rem sm:w-10rem md:w-12rem xl:w-9rem" />
            <Skeleton className="mb-2 w-8rem sm:w-12rem md:w-14rem xl:w-11rem" />
            <Skeleton className="mb-2 w-11rem sm:w-18rem md:w-22rem xl:w-16rem" />
            <Skeleton className="mb-2 w-8rem sm:w-12rem md:w-14rem xl:w-11rem" />
          </div>
        </div>
      </div>
      <Skeleton width="12rem" className="mb-2" />
    </Card>
  );
}

export default React.memo(ScientistSkeleton);
